import React,{useState, useEffect} from 'react';
import App from "../../App";
import {Link, useLocation, useParams, useHistory} from "react-router-dom";
import {MdArrowBack} from "react-icons/all";
import { getDetails } from "../../services/baseServices";
import PartnerOrderList from './PartnerOrderList';

const PartnerCommissionDetails = () => {
	const {id} = useParams()
	const location = useLocation();
	const history = useHistory()
	const {date} = location.state;
	const [partnerInfo, setPartnerInfo] = useState({})

	const getPartnerDetails = () =>{
		getDetails("partners", id)
			.then((res) => {
				setPartnerInfo(res?.data)
			})
			.catch((errMsg) => {
				console.log("Error Message: ", errMsg);
			});
	}
	useEffect(() =>{
		getPartnerDetails()
	},[id, location])

	return (
		<App layout={`boxed`}>
			<div className="main-content">
				<div className="page-header">
					<div className="page-title"/>
					<div className="ml-auto">
					<Link 
						to={`${process.env.PUBLIC_URL}/srMargin/details/${partnerInfo?.route?.id}`} 
						className={`btn btn-sm btn-link`}
					>
						<MdArrowBack/> Back to List
					</Link>
					</div>
				</div>

				<div className="card-block">
					<div className="block-header">
					<h4 className="block-title">Partner Details</h4>
					</div>
					<div className="block-body">
					<table className="info-table col-4">
						<tbody>
							<tr>
								<td style={{ width: "250px" }}>Partner Name</td>
								<td style={{ width: "20px", textAlign: "center" }}>:
								</td>
								<td className={`text-bold`}>{partnerInfo.name}</td>
							</tr>
							<tr>
								<td style={{ width: "50px" }}>Status</td>
								<td style={{ width: "20px", textAlign: "center" }}>:
								</td>
								<td className={`text-bold`}>{partnerInfo.status}</td>
							</tr>
							<tr>
								<td style={{ width: "50px" }}>Phone</td>
								<td style={{ width: "20px", textAlign: "center" }}>
									:
								</td>
								<td>{partnerInfo.phone}</td>
							</tr>
							<tr>
								<td style={{ width: "50px" }}>Address</td>
								<td style={{ width: "20px", textAlign: "center" }}>
									:
								</td>
								<td>{partnerInfo?.addresses?.address_line}</td>
							</tr> 
							<tr>
								<td style={{ width: "50px" }}>Area</td>
								<td style={{ width: "20px", textAlign: "center" }}>
									:
								</td>
								<td className='text-nowrap'>{partnerInfo.addresses?.area_name}</td>
							</tr>
							<tr>
								<td style={{ width: "50px" }}>Thana</td>
								<td style={{ width: "20px", textAlign: "center" }}>
									:
								</td>
								<td>{partnerInfo.addresses?.thana_name}</td>
							</tr>
							<tr>
								<td style={{ width: "50px" }}>District</td>
								<td style={{ width: "20px", textAlign: "center" }}>
									:
								</td>
								<td>{partnerInfo.addresses?.district_name}</td>
							</tr> 
						</tbody>
					</table>
					</div>
				</div>
			</div>
			<PartnerOrderList 
				partnerId={id}
				date={date}
				/>
		</App>
	)	
}

export default PartnerCommissionDetails